var _path;
import * as React from "react";
function SvgAngleLightRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.802 20.982L7.192 34.385a1.388 1.388 0 01-1.964 0l-.82-.82a1.388 1.388 0 010-1.965L16.226 20 4.419 8.4a1.388 1.388 0 010-1.964l.82-.82a1.388 1.388 0 011.964 0l13.61 13.402a1.398 1.398 0 01-.01 1.964zm14.79-1.964L21.98 5.615a1.388 1.388 0 00-1.964 0l-.82.82a1.388 1.388 0 000 1.965L31.015 20 19.208 31.6a1.388 1.388 0 000 1.964l.82.82a1.388 1.388 0 001.964 0l13.61-13.402a1.398 1.398 0 00-.01-1.964z"
  })));
}
export default SvgAngleLightRight;